import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Number5 = (props: Icon): React.ReactElement => (
  <svg
    style={{ ...style(props.size, props.height), ...props.style }}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M12,3.99999995 C7.58172197,3.99999995 3.99999995,7.58172197 3.99999995,12 C3.99999995,16.418278 7.58172197,20 12,20 C16.418278,20 20,16.418278 20,12 C20,7.58172197 16.418278,3.99999995 12,3.99999995 Z M12,5.33333329 C15.6818984,5.33333329 18.6666667,8.31810165 18.6666667,12 C18.6666667,15.6818984 15.6818984,18.6666667 12,18.6666667 C8.31810165,18.6666667 5.33333329,15.6818984 5.33333329,12 C5.33333329,8.31810165 8.31810165,5.33333329 12,5.33333329 Z M11.6533203,16.1074219 C12.6595052,16.1074219 13.4329427,15.8710937 13.9736328,15.3984375 C14.5143229,14.9257812 14.784668,14.2508138 14.784668,13.3735352 C14.784668,12.6323242 14.5599772,12.0486654 14.1105957,11.6225586 C13.6612142,11.1964518 13.0569661,10.9833984 12.2978516,10.9833984 C11.9755859,10.9833984 11.7052409,11.0084635 11.4868164,11.0585937 L11.4868164,11.0585937 L11.2988281,11.0961914 L11.4438477,9.5546875 L14.2475586,9.5546875 L14.2475586,8.14746094 L9.98828125,8.14746094 L9.69287109,12.1489258 L10.3535156,12.503418 C10.4967448,12.4604492 10.6829427,12.420166 10.9121094,12.3825684 C11.141276,12.3449707 11.3507487,12.3261719 11.5405273,12.3261719 C12.589681,12.3261719 13.1142578,12.7218424 13.1142578,13.5131836 C13.1142578,14.3439128 12.6075846,14.7592773 11.5942383,14.7592773 C11.2576497,14.7592773 10.9013672,14.7118327 10.5253906,14.6169434 C10.1494141,14.522054 9.81998698,14.3994141 9.53710937,14.2490234 L9.53710937,14.2490234 L9.53710937,15.6831055 C10.0742187,15.9659831 10.7796224,16.1074219 11.6533203,16.1074219 Z"
        id="path-1-number-4"
      ></path>
    </defs>
    <g
      id="Project-EOT"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Atom/icon/numbers/five-circle/line">
        <mask id="mask-2-number-4" fill="white">
          <use xlinkHref="#path-1-number-4"></use>
        </mask>
        <use
          id="Combined-Shape"
          fill="#FFFFFF"
          fillRule="nonzero"
          xlinkHref="#path-1-number-4"
        ></use>
        <g
          id="Group"
          mask="url(#mask-2-number-4)"
          fill={props.color || theme.palette.grey600}
        >
          <g id="🎨-color">
            <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
